"use client";

import React from "react";
import { Leaf, Flame, Coffee } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const alchemySteps = [{
  numeral: "01",
  title: "Feeding & Hydration",
  description: "To ensure your dog's comfort during deep tissue work and stretching, please avoid feeding a full meal within two hours of our session. Ensure fresh water is available before and after.",
  Icon: Leaf
}, {
  numeral: "02",
  title: "The Treatment Space",
  description: "Choose a quiet, familiar area with minimal distractions. A non-slip surface like a rug or yoga mat is ideal to provide stable footing and clinical-grade comfort during the massage.",
  Icon: Flame
}, {
  numeral: "03",
  title: "Post-Session Rest",
  description: "Plan for a quiet evening following the appointment. Bodywork facilitates significant physiological shifts; your dog will need time to process the treatment through deep, restorative rest.",
  Icon: Coffee
}];
export default function TheAlchemyOfCoffee() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="226208" id="preparation-guide" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="mb-20 text-center md:text-left">
          <h2 className="text-3xl md:text-5xl font-default font-semibold tracking-wide mb-4">
            Preparation Guide
          </h2>
          <div className="h-px w-24 bg-primary/40 mx-auto md:mx-0"></div>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {alchemySteps.map((step, i) => <div key={step.numeral} data-index={i} className="relative flex flex-col pt-12 group">
              {}
              <span className="absolute -top-4 -left-4 text-[8rem] md:text-[10rem] lg:text-[12rem] font-default font-bold text-primary/10 select-none leading-none z-0 transition-colors duration-500 group-hover:text-primary/20">
                {step.numeral}
              </span>

              {}
              <div className="relative z-10 flex flex-col items-start">
                <div className="mb-8 p-3 rounded-sm bg-primary/10 border border-primary/20 backdrop-blur-sm">
                  <step.Icon className="size-6 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl font-default font-semibold mb-4 text-foreground tracking-wide">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed font-sans text-sm md:text-base">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}